var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.0782C0 21.0385 5.23571 26.8263 12.0833 28V17.8885H8.45833V14H12.0833V10.8885C12.0833 7.3885 14.419 5.44483 17.7226 5.44483C18.769 5.44483 19.8976 5.6 20.944 5.75517V9.33333H19.0917C17.319 9.33333 16.9167 10.1885 16.9167 11.2782V14H20.7833L20.1393 17.8885H16.9167V28C23.7643 26.8263 29 21.0397 29 14.0782C29 6.335 22.475 0 14.5 0C6.525 0 0 6.335 0 14.0782Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.928293868ed2a216d63f668255537d3a.svg";
export { ForwardRef as ReactComponent };